import _ from 'lodash';
import { findSymbolReferenceRanges } from './symbol-eraql';

function replaceStringWithinRange(
  target: string,
  range: readonly [number, number],
  from: string,
  to: string
) {
  const before = target.slice(0, range[0]);
  const after = target.slice(range[1]);
  const substring = target.slice(range[0], range[1]);
  const replacedSubstring = substring.replace(from, to);
  return before + replacedSubstring + after;
}

const updateManyPlaces = (params: {
  from: string;
  to: string;
  era: string;
  metas: [number, number][];
}): string => {
  const { era, metas, from, to } = params;
  return _.sortBy(metas, ([start]) => [start])
    .reverse()
    .reduce(
      (curr, next) => replaceStringWithinRange(curr, next, from, to),
      era
    );
};

export const renameSymbolInEraql = (params: {
  from: string;
  to: string;
  eraql: string;
}): string => {
  return updateManyPlaces({
    from: params.from,
    to: params.to,
    era: params.eraql,
    metas: findSymbolReferenceRanges(params.eraql, params.from).map((x) => [
      x[0],
      x[1],
    ]),
  });
};
